import { Component } from "@angular/core";

/**
 * Shell for pages served to people without a Flow account (e.g. a supplier completing their
 * questionnaire from an emailed link). Deliberately has no sidebar, header or login gate.
 */
@Component({
	moduleId: module.id,
	selector: "publicRoute",
	styleUrls: ["publicRoute.css"],
	templateUrl: "publicRoute.html"
})
export class PublicRouteComponent {
}
